// extracted by mini-css-extract-plugin
export default {"container":"styles_container__GF-YS","spinner":"styles_spinner__MfQb-"};